import { TextField } from '@mui/material';

interface Props {
  valueMPa: number | null;
  onChange: (confiningPressureMPa: number | null) => void;
}

/**
 * Rock Triaxial confining pressure (σ₃, MPa) — the triaxial analogue of the
 * Direct Shear stresses editor (BUG-2026-0182). One OPTIONAL number per
 * sample × test cell, shown under the quantity; blank means the lab confirms
 * it with the client later.
 */
export const ConfiningPressureField = ({ valueMPa, onChange }: Props) => (
  <TextField
    size="small"
    variant="standard"
    type="number"
    label="σ₃ (MPa)"
    placeholder="optional"
    value={valueMPa ?? ''}
    onChange={(e) => {
      const raw = e.target.value;
      onChange(raw === '' ? null : Number(raw));
    }}
    inputProps={{ min: 0, step: 'any', style: { fontSize: 12, textAlign: 'center' }, autoComplete: 'off' }}
    InputLabelProps={{ shrink: true, sx: { fontSize: 11 } }}
    sx={{ width: 96 }}
  />
);
